import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = {
    hideAfter: Number
  }

  connect() {
    if (this.hasHideAfterValue) {
      setTimeout(() => {
        this.messageTarget.style.transition = "opacity 0.5s ease-out"
        this.messageTarget.style.opacity = "0"
        setTimeout(() => {
          this.messageTarget.remove()
        }, 500)
      }, this.hideAfterValue)
    }
  }
}
